<template>
  <div class="plate-footer">
    <div class="plate-footer__body">
      <v-btn
        v-if="!firstStep"
        :disabled="isLoading"
        color="secondary"
        @click="onBack"
      >
        <v-icon left dark> mdi-chevron-left</v-icon>
        Back
      </v-btn>

      <v-btn
        v-if="!lastStep"
        :disabled="isLoading || errors"
        color="primary"
        @click="onSubmit"
      >
        Continue
        <v-icon right dark> mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlateFooter',
  props: {
    onSubmit: {
      type: Function,
    },
    onBack: {
      type: Function,
    },
    isLoading: {
      type: Boolean,
    },
    firstStep: {
      type: Boolean,
    },
    lastStep: {
      type: Boolean,
    },
    errors: {
      type: Boolean,
    },
  },
};
</script>

<style scoped lang="scss">
.plate-footer {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;

  &__body {
    display: flex;
    gap: 10px;
  }
}
</style>